import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconChevronDown = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0)",
		children: /* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12.2533 5.89908C11.9012 6.26158 8.1826 9.80327 8.1826 9.80327C7.99355 9.99753 7.74553 10.0947 7.49924 10.0947C7.25122 10.0947 7.0032 9.99753 6.81588 9.80327C6.81588 9.80327 3.09727 6.26158 2.74345 5.89908C2.38963 5.53659 2.36535 4.88444 2.74345 4.49767C3.11982 4.11089 3.64709 4.08141 4.11018 4.49767L7.49924 7.74798L10.8883 4.49767C11.3514 4.08141 11.8769 4.11089 12.2533 4.49767C12.6314 4.88444 12.6071 5.53659 12.2533 5.89908Z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip02",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 11,
			height: 6.28571,
			fill: "white",
			transform: "translate(2 4)"
		})
	}) })]
});
export default SvgIconChevronDown;
